import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';
import Popup from './popup';

const ReferralAFiendChooseToShareModal = ({
  isShow,
  action,
  actionClose,
  content,
}) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    closePortalModalName();
  };

  return (
    <Popup
      isOpen={isShow}
      onClose={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
      content={content}
    />
  );
};

export default ReferralAFiendChooseToShareModal;
